import {LineItemsStore, StoreQuery, TimeColumn} from "../ps-models/lineitems-store";
import {values} from "ramda";
import {Message, Table} from "semantic-ui-react";
import {formatDateByTimeUnit} from "../ps-models";
import React from "react";
import {useStrings} from "./ui-strings";

export function IncomingPayments({store, includeLoanColumn = false, lenderField, loanField, interestLineItem, principalLineItem}: {
  lenderField?: string,
  loanField?: string,
  interestLineItem?: string,
  principalLineItem?: string,
  store: LineItemsStore, includeLoanColumn?: boolean }) {
  const st = useStrings();

  if(!lenderField){
    lenderField = "source_Input Data-Borrower";
  }

  if(!loanField){
    loanField = "source_Input Data-Loan";
  }

  if(!interestLineItem){
    interestLineItem = "Projected - External Debt - Interest";
  }

  if(!principalLineItem){
    principalLineItem = "External Debt - Principal Repayment";
  }




  let result = store.query(StoreQuery
    .byNames([interestLineItem, principalLineItem], true)
    .and(StoreQuery.withField(lenderField))
  );

  let nextPayments: { date: Date, value: string, paymentType: string, lender: string, loan?: string }[] = [];
  const nextPaymentsLenderPaymentTypeMap: Record<string, number> = {};
  for (let row of result.rows) {
    for (let cell of values(row)) {
      const lenderCell = result.rowColumnValue(row, `fields.${lenderField}`);
      const loanCell = result.rowColumnValue(row, `fields.${loanField}`);
      const paymentType = result.rowColumn(row, `store_sourcelabel`)?.text;
      if(!paymentType){
        continue;
      }
      if (!lenderCell) {
        continue;
      }
      if(includeLoanColumn && !loanCell){
        continue;
      }
      let timeCol = (result.columnById(cell.columnId) as TimeColumn);
      let today = new Date().getTime();
      if (timeCol && timeCol.time && today < timeCol.time && cell.value !== 0) {
        nextPayments.push({
          date: new Date(timeCol.time),
          value: cell.text,
          paymentType,
          lender: lenderCell as string,
        ...(includeLoanColumn ? {loan: loanCell as string} : {}),
        });
      }
    }
  }

  // sort by date
  nextPayments.sort((a, b) => a.date.getTime() - b.date.getTime());
  nextPayments = nextPayments.filter((p) => {
    const key = `${p.lender}-${p.paymentType}`;
    if(nextPaymentsLenderPaymentTypeMap[key]) {
      nextPaymentsLenderPaymentTypeMap[key]++;
      if(nextPaymentsLenderPaymentTypeMap[key] > 2) {
        return false;
      } else {
        return true;
      }
    } else {
      nextPaymentsLenderPaymentTypeMap[key] = 1;
      return true;
    }
  });

  return (<div>
      <Message warning style={{marginTop: "15px", marginBottom: "15px"}}>
        <div><strong>{st("Upcoming Loan Payments")}</strong></div>
        <Table compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Payment Type</Table.HeaderCell>
              <Table.HeaderCell>Next Payment Date</Table.HeaderCell>
              {includeLoanColumn && <Table.HeaderCell>{st("Loan")}</Table.HeaderCell>}
              <Table.HeaderCell>{st("Borrower")}</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>

            </Table.Row>
          </Table.Header>
          <Table.Body>
            {nextPayments.map((p, i) => (<Table.Row>
                <Table.Cell>{p.paymentType}</Table.Cell>
                <Table.Cell>{formatDateByTimeUnit(p.date, "days")}</Table.Cell>
                {includeLoanColumn && <Table.Cell>{p.loan}</Table.Cell>}
                <Table.Cell>{p.lender}</Table.Cell>
                <Table.Cell>{p.value}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Message></div>
  );
}